// ACTION CREATOR SET_SAVE_NETWORK_ARRAY
export const SET_SAVE_NETWORK_ARRAY = 'SET_SAVE_NETWORK_ARRAY';

// ACTION CREATOR setSaveNetworkArray
export const setSaveNetworkArray = (value) => ({
  type: SET_SAVE_NETWORK_ARRAY,
  value,
});

// ACTION CREATOR SET_SAVE_NETWORK_MARKER_COMPONENT
export const SET_SAVE_NETWORK_MARKER_COMPONENT = 'SET_SAVE_NETWORK_MARKER_COMPONENT';

// ACTION CREATOR setSaveNetworkMarkerComponent
export const setSaveNetworkMarkerComponent = (value) => ({
  type: SET_SAVE_NETWORK_MARKER_COMPONENT,
  value,
});

// ACTION CREATOR SET_NETWORK_MARKER
export const SET_NETWORK_MARKER = 'SET_NETWORK_MARKER';

// ACTION CREATOR setNetworkMarker
export const setNetworkMarker = (value) => ({
  type: SET_NETWORK_MARKER,
  value,
});

// ACTION CREATOR SET_NETWORK_GRID
export const SET_NETWORK_GRID = 'SET_NETWORK_GRID';

// ACTION CREATOR setNetworkGrid
export const setNetworkGrid = (value) => ({
  type: SET_NETWORK_GRID,
  value,
});

// ACTION CREATOR FETCH_NETWORK_FULL_DATA
export const FETCH_NETWORK_FULL_DATA = 'FETCH_NETWORK_FULL_DATA';

// ACTION CREATOR fetchNetworkFullData
export const fetchNetworkFullData = (query, server, glassapi) => ({
  type: FETCH_NETWORK_FULL_DATA,
  query,
  server,
  glassapi,
});

// ACTION CREATOR SAVE_NETWORK_FULL_DATA
export const SAVE_NETWORK_FULL_DATA = 'SAVE_NETWORK_FULL_DATA';

// ACTION CREATOR saveNetworkFullData
export const saveNetworkFullData = (value) => ({
  type: SAVE_NETWORK_FULL_DATA,
  value,
});

// ACTION CREATOR SET_NETWORK_NAME
export const SET_NETWORK_NAME = 'SET_NETWORK_NAME';

// ACTION CREATOR setNetworkName
export const setNetworkName = (value) => ({
  type: SET_NETWORK_NAME,
  value,
});

// ACTION CREATOR SET_SAVE_MARKER_SELECTED
export const SET_SAVE_MARKER_SELECTED = 'SET_SAVE_MARKER_SELECTED';

// ACTION CREATOR setSaveMarkerSelected
export const setSaveMarkerSelected = (value) => ({
  type: SET_SAVE_MARKER_SELECTED,
  value,
});
